import React, {useEffect, useState} from 'react';
import DeliveryDateStepOne from './DeliveryDateStepOne';
import DeliveryDateStepTwo from './DeliveryDateStepTwo';

export default function DeliveryDateMain(props) {
  const [deliveryDateStep, setDeliveryDateStep] = useState(props.setInnerStep ? 2 : 1);
  const store = props.idfStore;
  useEffect(() => {
    if (store.page == 'DeliveryDate' && deliveryDateStep == 2) {
      setDeliveryDateStep(1);
    }
     window.scrollTo(0, 0);
  }, [store.page]);

  return (
    <div className='delivery-date-main step'>
      {deliveryDateStep == 1 ? (
        <DeliveryDateStepOne
          {...props}
          onClickNavigation={props.onClickNavigation}
          setDeliveryDateStep={setDeliveryDateStep}
          store={store}
        />
      ) : (
        <DeliveryDateStepTwo
          {...props}
          onClickNavigation={props.onClickNavigation}
          setDeliveryDateStep={setDeliveryDateStep}
          store={store}
        />
      )}
    </div>
  );
}
